






























































import Vue, { VueConstructor } from 'vue'
import { ValidationObserver } from 'vee-validate'

const defaultModel = () => ({
  firstname: '',
  lastname: '',
  email: '',
  phone: '',
  role: '',
  organizationId: ''
})

interface ComponentWithValidator extends Vue {
  $refs: {
    validator: InstanceType<typeof ValidationObserver>
  }
}

export default (Vue as VueConstructor<ComponentWithValidator>).extend({
  props: {
    value: {
      type: Object,
      default: defaultModel
    },
    roles: {
      type: Array,
      default: () => []
    },
    organizations: {
      type: Array,
      default: () => []
    }
  },

  data() {
    return {
      model: {
        ...defaultModel(),
        ...this.value
      }
    }
  },

  watch: {
    value: {
      deep: true,
      handler(newValue) {
        this.model = newValue
      }
    },
    'model.organizationId'(orgId: string) {
      if (!this.organizations.length) return
      this.model.role = ''
      const org = (this.organizations as any[]).find((o: any) => o.id === orgId)
      if (org) {
        this.$emit('organization-change', org)
      }
    }
  },

  methods: {
    validate() {
      this.$refs.validator.validate().then((isValid: boolean) => {
        if (isValid) {
          const payload: any = {
            ...this.model,
            phone: this.model.phone.replace(/\s/g, '')
          }
          if (!payload.organizationId) {
            delete payload.organizationId
          }
          this.$emit('submit', payload)
        }
      })
    },

    setErrors(this: any, errors: any) {
      errors.forEach((error: any) => {
        Object.keys(error.constraints).forEach((rule: string) => {
          switch (rule) {
            case 'isUnique':
              this.$refs.validator.setErrors({
                [error.property]: 'Déjà utilisé'
              })
              break
          }
        })
      })
    }
  }
})
